export default "__VITE_ASSET__8S3LN3w1__"